// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCoffee = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path fillRule="evenodd" d="M18.87 6l-1.037 16H6.167L5.13 6H4V4h2V2h12v2h2v2zM7.134 6l.907 14h7.918l.907-14z" />
  );
export default SvgIconCoffee;
